module.exports = __webpack_public_path__ + "fonts/Aller_Bd.ec478fc7.ttf";